import { PortableText } from '@portabletext/react'
import { BlockContent, Figure } from 'codegen/schema'
import { myPortableTextComponents } from 'context-providers/PortableTextComponents'
import { urlForImage } from 'lib/sanity'
import Image from 'next/image'
import Link from 'next/link'
import { memo } from 'react'

import { RichTextContainer } from './rich-text-content.styles'

interface RichTextContentProps {
  heroImage?: Figure | undefined
  body: BlockContent | undefined
}

export const RichTextContent = memo(function RichTextContent(props: RichTextContentProps) {
  const { heroImage, body } = props

  const srcUrl = heroImage?.image?.asset._ref
  const href = heroImage?.href
  const alt = heroImage?.alt
  const title = heroImage?.title
  const hideHeroImage = heroImage?.hide
  const openInNewTab = Boolean(heroImage?.openInNewTab)

  const width = 808
  const height = Math.floor(width * ((heroImage?.heightToWidthRatio || 33.33) / 100))

  let imageSrc
  if (!hideHeroImage && srcUrl) imageSrc = urlForImage(srcUrl).height(height).width(width).fit('crop').url() || ''

  //TODO: n: image is not cropped correctly

  const imageElement = <Image src={imageSrc || ''} width={width} height={height} alt={alt || ''} title={title} />

  return (
    <RichTextContainer>
      {/* if imageSrc and href are set, render the image inside a Link */}
      {imageSrc && href && (
        <Link target={openInNewTab ? '_blank' : '_self'} rel="noopener noreferrer" href={href}>
          {imageElement}
        </Link>
      )}
      {/* if imageSrc is set and href is not set, render the image */}
      {imageSrc && !href && imageElement}

      {body && (
        <PortableText
          // blocks={body}
          value={body}
          components={myPortableTextComponents}
        />
      )}
    </RichTextContainer>
  )
})
